const Loader = () => {
  return (
    <div className="f-loader-wrap" style={{ minHeight: '100vh' }}>
      <div className="f-loader-orbit" aria-hidden />
      <div className="f-loader-label">Loading…</div>
    </div>
  );
};

export default Loader;
